import styled from 'styled-components';

export const StyledToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => `${theme.spacing(2)}px`};
`;
